export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9002.8554e2fe.jpg";